import { UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IEmptyListQuestionsProps {
  newbuildingName: string;
}
export const EmptyListQuestions = ({ newbuildingName }: IEmptyListQuestionsProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['description']}>
        <div className={styles['title']}>
          <UIHeading2>Ваш вопрос на Циан о ЖК «{newbuildingName}» будет первым</UIHeading2>
        </div>
        <div className={styles['subtitle']}>
          <UIText1>Вам ответит застройщик или один из&nbsp;пользователей Циан</UIText1>
        </div>
      </div>
    </div>
  );
};
